import { useCloudFarmDataSetCount } from "../hooks/useCloudFarmDataSetCount";
import cropr from "../../shared/utils/cropr";
import { gettext } from "../../shared/utils/legacy";
import { openCloudFarmPage } from "../utils";
import React from "react";
import moment from "moment";
import "./DashBoardSummaryTile.scss";
import DashboardSummaryInfo from "./DashboardSummaryInfo";

function DatasetCountComponent() {
  const today = moment();
  const startDate = today.clone().isoWeekday(1), //Monday
    endDate = today.clone().isoWeekday(7); //Sunday
  const cloudFarmDataSetCount = useCloudFarmDataSetCount(startDate.unix(), endDate.unix());
  return (
    <ul className="list-group">
      <li>
        {(!(cropr.features.cloudfarm || cropr.features.cloudfarm_contract) && (
          <DashboardSummaryInfo category={"cloudfarm"} />
        )) || (
          <a
            href={"/cropr/dashboard/#"}
            className="text-black"
            title={gettext("Go to Cloudfarm")}
            data-metrics_category="summary_widget"
            data-metrics_sub_category="datasets"
            onClick={() => openCloudFarmPage(startDate.unix(), endDate.unix())}
          >
            {cloudFarmDataSetCount}{" "}
            {cloudFarmDataSetCount === 1 ? gettext("new dataset") : gettext("new datasets")}
          </a>
        )}
      </li>
    </ul>
  );
}
const DashboardSummaryDataset = () => (
  // - Deze week x datasets
  // - Klik: naar cloudfarm
  <div className="col-4 col-md py-3">
    <h6 className="text-muted mb-3">
      {gettext("Cloudfarm")} {gettext("week")} {moment().week()}
    </h6>
    <DatasetCountComponent />
  </div>
);
export default DashboardSummaryDataset;
